'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

interface PostHogProviderProps {
  children: React.ReactNode;
}

const PostHogProvider = ({ children }: PostHogProviderProps) => {
  useEffect(() => {
    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

    if (!posthogKey) {
      return;
    }

    // don't track in development unless explicitly enabled
    if (process.env.NEXT_PUBLIC_NODE_ENV === 'development' && process.env.NEXT_PUBLIC_POSTHOG_DEV_TRACKING !== 'true') {
      console.log('PostHog disabled in development. Set NEXT_PUBLIC_POSTHOG_DEV_TRACKING=true to enable.');

      return;
    }

    posthog.init(posthogKey, {
      api_host: '/ingest',
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: '2025-05-24',
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      person_profiles: 'identified_only',
      debug: process.env.NEXT_PUBLIC_NODE_ENV === 'development' && process.env.NEXT_PUBLIC_POSTHOG_DEBUG === 'true',
    });
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};

export default PostHogProvider;
